function IconArrowBack() {
  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 18 18" fill="none">
      <path d="M11.7002 2.7L5.4002 8.55L11.7002 14.4" stroke="#3D3B32" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
}

export default IconArrowBack;
